import React, {useMemo, useState, useRef, useEffect} from "react";
import HeaderComponent from "../../components/HeaderComponent";
import "./../../utils/Style/pages/Branches.scss";
import {useTable, usePagination} from "react-table";
import NewBranchTemplate from "./NewBranchTemplate";
import useBranchAPI from "../../api/branchAPI";
import {useLocation, useNavigate} from "react-router-dom";
import {useToast} from "@chakra-ui/react";
import BranchDetailsTillRow from "../../components/Branch/BranchDetailsTillRow";
import BranchDetailsSkeleton from "../../components/skeletons/BranchDetailsSkeleton";


function BranchDetails() {
    const componentRef = useRef(null);
    const location = useLocation();
    const {
        branchDetails,
        GetBranchDetails,
        GetBranchTills,
        GenerateBranchTillOTP,
        branchTills,
        remainingTills,
        setBranchTills,
        setRemainingTills,
        AssignTill,
        initialBranchTillsTable,
        setInitialBranchTillsTable,
        initialRemainingBranchTills,
        setInitialRemainingBranchTills,
        branchDetailsLoading
    } = useBranchAPI();

    const toast = useToast();
    const toastRef = useRef(null);

    const [canAddTillRow, setCanAddTillRow] = useState(true);
    const [addText, setAddText] = useState("Add");
    let branchID = location.state?.data?.BranchID;

    const navigate = useNavigate();

    useEffect(() => {
        GetBranchDetails(branchID);
        GetBranchTills(branchID);
    }, []);

    useEffect(() => {
        setInitialRemainingBranchTills(remainingTills);
    }, [remainingTills]);


    const handleAddRow = (e) => {
        e.preventDefault();
        if (remainingTills.length <= 0) {
            toastRef.current = toast({
                position: "top",
                title: "Info",
                description: "No Remaining Tills! Add a till from Edit Branch Section.",
                status: "info",
                duration: "5000",
                isClosable: "false",
            });
        } else {
            if (canAddTillRow) {
                setCanAddTillRow(false);
                const newItem = {
                    MerchantUserOnBoardID: 0,
                    ReferenceNo: null,
                    Description: null,
                    Status: "NEW",
                    DeviceID: "",
                    OTP: "",
                    TillCount: 2,
                };
                setBranchTills((prev) => [newItem, ...prev]);
                setAddText("Remove");
            } else {
                setCanAddTillRow(true);
                setBranchTills(initialBranchTillsTable);
                setRemainingTills(initialRemainingBranchTills);
                setAddText("Add");
            }
        }
    };

    // const handleGenerateOTP = async (MerchantUserOnBoardID, TillBranchID) => {
    //     const data = await GenerateBranchTillOTP(
    //         MerchantUserOnBoardID,
    //         TillBranchID
    //     );
    //     await GetBranchTills(branchID);
    //     setCanAddTillRow(true);
    // };


    const columns = useMemo(
        () => [
            {
                Header: "Till",
                accessor: "ReferenceNo",
            },
            {
                Header: "Type of POS",
                accessor: "Description",
                Cell: ({row}) => {
                    return (<div>{row.original.assign.Description}</div>)
                }
            },
            {
                Header: "Status",
                accessor: "Status",
            },
            {
                Header: "Device ID",
                accessor: "DeviceID",
            },
            {
                Header: "CODE/OTP",
                accessor: "OTP",
                Cell: ({row}) => {
                    return row.original.Status === "EXPIRED" ? <div>N/A</div> : <div>{row.original.OTP}</div>
                }
            },
            {
                Header: () => {
                },
                disableSortBy: true,
                accessor: "resetGenerate",
            },
            {
                disableSortBy: true,
                accessor: "assign",
            },
        ],
        [canAddTillRow, remainingTills]
    );

    const data = useMemo(
        () =>
            branchTills.map((till) => {
                return {
                    ReferenceNo: till.ReferenceNo,
                    currentTypePOS: till.Description,
                    Status: till.Status,
                    DeviceID: till.DeviceID,
                    OTP: till.OTP,
                    resetGenerate: till,
                    assign: till,
                };
            }),
        [branchTills]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } =
        useTable({columns, data}, usePagination);

    return (
        <>
            <HeaderComponent title="Branches"/>
            <div className="BranchesPage">
                <div className="container-fluid Branchescontainer">
                    {/*<button*/}
                    {/*onClick={()=>{*/}
                    {/*    navigate("/branches")*/}
                    {/*}*/}
                    {/*}>Back</button>*/}
                    <div className="row">
                        <div className="col-lg-10 col-sm-12 ">
                            <div>
                                {
                                    branchDetailsLoading ? (
                                        <BranchDetailsSkeleton/>
                                    ) : (
                                        <div className="BranchDetails">
                                            <div className="row mt-4">
                                                <div className="col-2 title">Branch Details</div>
                                                <div className="col-4 detail"></div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-2 title">Name</div>
                                                <div className="col-4 detail">{branchDetails.Name || null}</div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-2 title">Merchant ID</div>
                                                <div className="col-4 detail">{branchDetails.MerchantID || null}</div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-2 title">Region</div>
                                                <div
                                                    className="col-4 detail">{branchDetails.Region !== undefined && branchDetails.Region.label}</div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-2 title">Location</div>
                                                <div className="col-4 detail">{branchDetails.Description || null}</div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-2 title">Supervisor</div>
                                                <div className="supervisors-list col-5">
                                                    {branchDetails.BranchEmployee !== undefined && branchDetails.BranchEmployee.map((employee, index) => (
                                                        <div key={index} className="detail">{employee.Name}</div>
                                                    ))
                                                    }
                                                </div>

                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-2 title">Payment Options</div>
                                                <div className="col-4 detail">POS & Request To Pay</div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-2 title">Number of Tills</div>
                                                <div
                                                    className="col-4 detail">{branchDetails.tillReferences !== undefined && branchDetails.tillReferences.length}</div>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                        <div className="col-lg-2 col-sm-12"></div>
                    </div>

                    <div className="row">
                        <div className="till_tables" ref={componentRef}>
                            <table {...getTableProps()} className="AllTable">
                                <thead>
                                {headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                        {headerGroup.headers.map((column) => (
                                            <th {...column.getHeaderProps()}>
                                                <span>{column.render("Header")}</span>
                                            </th>
                                        ))}
                                        <th>
                                            <button className="add-btn" onClick={handleAddRow}>
                                                {addText}
                                            </button>
                                        </th>
                                    </tr>
                                ))}
                                </thead>
                                <tbody {...getTableBodyProps()}>
                                {rows.map((row) => {
                                    prepareRow(row);
                                    return (
                                        <BranchDetailsTillRow
                                            row={row}
                                            setRemainingTills={setRemainingTills}
                                            initialRemainingBranchTills={initialRemainingBranchTills}
                                            GetBranchTills={GetBranchTills}
                                            setBranchTills={setBranchTills}
                                            setInitialBranchTillsTable={setInitialBranchTillsTable}
                                            setInitialRemainingBranchTills={setInitialBranchTillsTable}
                                            AssignTill={AssignTill}
                                            BranchID={branchID}
                                            setCanAddTillRow={setCanAddTillRow}
                                            setAddText={setAddText}
                                        />
                                    );
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <button className="newbranch" onClick={() => {
                        navigate(`/branches/edit/${branchID}`, {
                            state: {
                                isEdit: true,
                                data: {BranchID: branchID},
                            },
                        });
                    }}>Edit Branch
                    </button>

                </div>
            </div>
        </>
    );
}

export default BranchDetails;